import { InvalidateQueryFilters, useQuery, useQueryClient } from '@tanstack/react-query'
import { getShows } from 'api/show'
import { useState } from 'react'

export const useShowsUser = () => {
    const [searchTerm, setSearchTerm] = useState('')
    const queryClient = useQueryClient()

    const handleSearch = (value: string) => {
        setSearchTerm(value)
        queryClient.invalidateQueries(['shows'] as InvalidateQueryFilters)
    }

    const { data, isLoading, error } = useQuery({
        queryKey: ['shows', searchTerm],
        queryFn: () => getShows(searchTerm),
    })

    return {
        data,
        isLoading,
        error,
        handleSearch,
    }
}
